import React from "react";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsis } from "@fortawesome/free-solid-svg-icons";
import { Dropdown } from "react-bootstrap";
import { DropdownMenuItem } from "../../../components/utilities"
import toast from "react-hot-toast";
import { openReviewSummaryModal } from "../../../components/modals/client-review-summary";

const ActionColumnParent = styled.td`
    width: ${({ width }) => width}%;
    cursor: pointer;
    vertical-align: middle;
    text-align: ${props => props.textAlign ?? "left"};
`;

const ActionColumnParentToggle = React.forwardRef(({ ...rest }, ref) => (
    <div ref={ref} {...rest}>
        <FontAwesomeIcon icon={faEllipsis} />
    </div>
));

export const CompletedReviewsTableRowActionColumn = ({
    data,
    width = 2.5
}) => {

    const menuId = React.useId();
    
    const { reviewId, masterAccountId, masterAccountName } = data;

    const onOpenReviewSummary = () => {
        if (!data.masterAccountId) {
            toast.error('Could not open Review Summary. Invalid or missing Master Account.');
            return;
        }
        openReviewSummaryModal(masterAccountId, masterAccountName, reviewId);
    };

    return (
        <ActionColumnParent width={width}>
            <Dropdown className="caret-off">
                <Dropdown.Toggle id={menuId} as={ActionColumnParentToggle} />
                <Dropdown.Menu style={{ maxWidth: '14rem' }}>
                    {masterAccountId && (
                        <DropdownMenuItem icon="fas fa-list" onClick={onOpenReviewSummary}>View Review Summary</DropdownMenuItem>
                    )}</Dropdown.Menu>
            </Dropdown>
        </ActionColumnParent>
    )
};